/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import RegionForm from './RegionForm';
import * as validations from '../../validations/validations';
import * as regionActions from '../../actions/regionActions';
import * as paisActions from '../../actions/paisActions';
import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
 import $ from 'jquery';


class ManageRegionForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			region:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.id;
        let pageInfo={ 
            page:'region', 
            idioma:this.props.idioma     
        }; 
   this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
       this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
        
         this.props.paisActions.getPaisCombo( this.props.user).then( ()=>{ 
           
           }) 
            .catch(error=>{ 
              toastr.error(error); 
            });
        
        if(id && id>0 ){
            
           this.props.regionActions.getRegion(id, this.props.user).then( region=>{
               this.setState({"region":region});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        
		
    }
    

    handleChange=(event, data)=> {

        let region = this.state.region;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		region[field[0]]= value;
		else{
             if(!region[field[0]]){
                    region[field[0]]={}
                }
			region[field[0]][field[1]]= value;
		}
        
		
        this.setState({"region": region});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let region=this.state.region;
              
        if(!validations.requerido(region.paisId)){
            errors.paisId=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(region.abreviatura)){
            errors.abreviatura=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(region.nombre)){
            errors.nombre=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.regionActions.save(this.state.region, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            //this.props.history.push('/regions');
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <RegionForm 
                    strings={this.state.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.region}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    paisCombo={genericFormattedForDropdown(this.props.paisCombo)}  
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    let id = ownProps.match.params.id;
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        id,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form,
        paisCombo:state.paisCombo
    }

}

function mapDispatchToProps(dispatch){

	return {   
            showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            paginaActions: bindActionCreators(paginaActions, dispatch),
            regionActions: bindActionCreators(regionActions, dispatch),
            paisActions: bindActionCreators(paisActions, dispatch),
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageRegionForm);